module.exports = __webpack_public_path__ + "img/Proliferation-LUCA_10X_LU.49ccdc88.png";